'use client';

import { reactive } from '@legendapp/state/react';
import { $React } from '@legendapp/state/react-web';
import { useSearchFromContext } from '@/components/forms/SearchFromProvider';
import PromoCodeField from '@/components/forms/fields/PromoCodeField';
import { cn } from '@/lib/cn';
import { HeroSearchFormColumn, type HeroSearchFormColumnProps } from './HeroSearchFormColumn';

const ReactivePromoCodeField = reactive(PromoCodeField);

export type HeroSearchFormActionColumn = HeroSearchFormColumnProps;
export function HeroSearchFormActionColumn({ children, className, ...props }: HeroSearchFormActionColumn) {
    const formState = useSearchFromContext();
    return (
        <HeroSearchFormColumn className={cn('gap-4 flex-row items-center justify-between flex-1 px-4 xl:px-4', className)} {...props}>
            <ReactivePromoCodeField label="Promo code" $value={() => formState.promoCode.get()} onChange={(e) => formState.promoCode.set(e.target.value?.trim())} />
            <$React.a
                data-testid="search-form-submit-btn"
                $href={() => formState.getSearchUrl()?.href || '#'}
                $className={() =>
                    cn('btn btn-primary h-13 text-white xl:px-7', {
                        'bg-base-50': !formState.isValid(),
                    })
                }
                aria-label="Search for vehicles"
                $disabled={() => !formState.isValid()}
                onClick={() => {
                    formState.trackBookingInitiated();
                }}
            >
                Search for vehicles
            </$React.a>
        </HeroSearchFormColumn>
    );
}
